import { get } from '@/api/base'

const configApi = {
  get: async () => {
    const response = await get({ path: 'config' })
    return response.success ? response.data.config : null
  },
}

export default configApi
